<template>
  <div>
    <my-head></my-head>
    <div class="demand minH">
      <div class="crumbs">
        首页 > 运营服务 >
        <span style="color: #1d2129">IP需求开发</span>
      </div>

      <div class="title">IP需求开发</div>

      <div class="content">
        为潜在专利需求人提供咨询方案和技术导入服务，打造致力于解决企业IP需求难题的需求服务平台，主要通过免费发布自主对接、委托服务针对性对接及悬赏服务精准对接的方式为需求方匹配专利及机构、寻找需求解决方案；专家入驻平台后亦可承接技术。
      </div>

      <img
        src="../../assets/demand_1.png"
        class="demand_img"
      />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
};
</script>

<style lang="scss">
.demand {
  width: 80%;
  margin: 24px auto 60px;
  .demand_img {
    width: 100%;
    margin-bottom: 130px;
  }
  .content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .title {
    font-size: 30px;
    margin-bottom: 32px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
